<template>
	<div id="paymentView">
    <mu-stepper :activeStep="1" v-if="!isLoading">
      <mu-step>
        <mu-step-label>
          {{$t('message.labelProceed')}}
        </mu-step-label>
      </mu-step>
    </mu-stepper>
    <div class="paymentModal loading" v-if="isLoading">
      <mu-content-block style="text-align: center">
				<mu-circular-progress :size="32"></mu-circular-progress>
				<div v-text="$t('message.loadingText')"></div>
			</mu-content-block>
		</div>
		<div class="paymentModal" :class="{'processedOrCancelled' : isPaymentCancelled || hasPaymentProcessed }" v-if="!isLoading">
      <mu-row>
        <mu-col width="100" tablet="100" desktop="100" class="panel" v-if="isPaymentCancelled">
          <div class="block cancelled">
            <h1>{{$t('message.paywallPaywallFailed')}}</h1>
            <p>{{$t('message.paywallPaywallFailedExplain')}}</p>
            <mu-flat-button type="button" class="button" @click="goTo('Payment')" label="Try again" />
          </div>
        </mu-col>
        <mu-col width="100" tablet="100" desktop="100" class="panel" v-if="hasPaymentProcessed">
          <div class="block success" v-if="hasPaymentProcessed">
            <div id="invoice">
              <h1>Payment Receipt</h1>
              <div id="paymentDetails">
                <p v-if="getParam('st') === 'Completed'">{{$t('message.paywallStatusComplete')}}</p>
                <p v-if="getParam('st') === 'Pending'">{{$t('message.paywallStatusPending')}}</p>
                <p v-if="getParam('st') === 'Failed'">{{$t('message.paywallStatusFailed')}}</p>
                <table class="table">
                  <tbody>
                  <tr>
                    <td>Description</td>
                    <td v-text="getParam('item_name')"></td>
                  </tr>
                  <tr>
                    <td>TXNID</td>
                    <td>
                      {{ getParam('tx') }}
                      <span class="keepsafe">Keep safe</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td v-text="getParam('st')"></td>
                  </tr>
                  <tr>
                    <td>Price</td>
                    <td>{{ getParam('amt') }}{{ getParam('cc') }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <mu-flat-button v-if="getParam('st') === 'Completed'" icon="verified_user" type="button" class="button getStartedBtn" @click.native="goToGetStarted" label="Get started" />
              <mu-flat-button icon="print" type="button" class="button printBtn" @click.native="printInvoice" label="Print a copy" />
            </div>
          </div>
        </mu-col>
        <mu-col width="100" tablet="60" desktop="60" class="panel" v-if="!isPaymentCancelled && !hasPaymentProcessed">
          <div class="block payment">
            <h1>Personalise your program</h1>
            <p>Get access and support for {{ paypal.currency_sym + paypal.amount }}. <br /> Join over {{numeral(stats.count).format('0,0')}} people today</p>
            <paypal-form :paypal="paypal" />
            <div class="cards">
              <img src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/cc-badges-ppppcmcvdam.png" alt="Pay with PayPal, PayPal Credit or any major credit card" />
            </div>
            <div class="seperator">
              <div class="overlay">
                <span>Or</span>
              </div>
            </div>
            <form id="voucherForm" @submit.prevent="processVoucher" novalidate>
              <div id="voucher">
                <mu-row :gutter="true">
                  <mu-col tablet="65" desktop="65" width="65">
                    <mu-text-field id="voucherTxt" hintText="Voucher code" v-model="voucher.code" fullWidth :min="20" />
                  </mu-col>
                  <mu-col tablet="30" desktop="30" width="30">
                    <!-- Firefox fix -->
                    <button type="submit" style="display: none"></button>
                    <mu-flat-button id="submitBtn" @click.native="processVoucher" type="button" label="Redeem" class="apply" :disabled="(voucher.code.length <= 3) || voucher.isSending" color="#FFF" fullWidth />
                  </mu-col>
                </mu-row>
              </div>
              <div class="message" :class="{ error : voucher.error === true, success : voucher.error === false }" v-text="voucher.isSending ? 'Processing...' : voucher.message"></div>
            </form>
            <p>After paying, you will be asked to customise your program. You will receive:</p>
            <div class="benefits">
              <ul>
                <li>Award-winning structured education on therapeutic nutrition</li>
                <li>Practical Action Points to achieve your health goal</li>
                <li>Daily meal plans for 12 weeks to kick start your journey</li>
                <li>Tailored messages from your mentor to keep you on track</li>
                <li>Support from behavioural health mentors</li>
                <li>Peer support 24/7 from {{numeral(stats.count).format('0,0')}} members</li>
                <li>Integrated food diary with food search and barcode scanner</li>
                <li>Integrated health tracking and data exporting</li>
                <li>Searchable library of recipes tailored to your preferences</li>
                <li>Daily updated news, research and expert opinions</li>
                <li>Library of resources</li>
                <li>Access on any device on web, iOS and Android</li>
                <li>Connect to Apple Health and sync your data</li>
                <li>Receive constantly updated features and enhancements</li>
                <li>Sync with FitBit</li>
                <li>Access on your Apple Watch</li>
                <li>Friendly technical support</li>
              </ul>
            </div>
          </div>
        </mu-col>
        <mu-col v-if="!hasPaymentProcessed && !isPaymentCancelled" width="100" tablet="40" desktop="40" class="panel">
          <h2>Free health tracking</h2>
          <p>Continue without paying to get health and nutrition tracking. Pay to upgrade instantly at any time.</p>
          <mu-flat-button @click.native="continueFree()" type="button" class="button paypalBtn free" label="Proceed for free" />
        </mu-col>
      </mu-row>
		</div>
	</div>
</template>
<script>
	import paymentApi from '../../api/Payment';
	import userApi from '../../api/User';
	import PaypalForm from './PayPalForm/index.vue';
  import pusher from '../../helpers/PusherManager';
  import config from '../../config/index';
	import $ from 'jquery';
	import _ from 'lodash';
  import axios from 'axios';
  import numeral from 'numeral';
  import AuthenticationManager from "../../helpers/AuthenticationManager";
	export default {
		components: {
      PaypalForm,
		},
		data() {
			return {
        stats: {},
				isLoading: true,
				status: {},
				paypal: {},
				voucher: {
					code: "",
					error: false,
					message: "",
					isSending: false,
				},
			}
		},
		methods: {
      numeral(num) {
        return numeral(num);
      },
      getStats() {
        let self = this;
        axios.get(config.apiUrl + 'stats').then(response => {
          self.stats = response.data;
        });
      },
      fetchPaymentDetails() {
        let self = this;
        paymentApi.getPayPalDetails().then(response => {
          self.paypal = response.data;
          self.paypal.hasSubmitted = false;
        }).catch(error => {
          if(error.response.data.error === true) {
           self.goTo('Login');
          }
        });
      },
			getUserPaidStatus() {
				let self = this;
        if (AuthenticationManager.hasToken()) {
          const tokenObject = AuthenticationManager.getToken();
          AuthenticationManager.refreshAccessToken(tokenObject).then( ()=> {
            if (_.includes(AuthenticationManager.parseJwt().scope, "standard_tasks")) {
              self.isLoading = false;
              self.$store.commit('setPaymentStatus', true);



              if(!self.getParam('success') ) {
                self.goTo('Dashboard');
              }
            }
          });
        }
			},
			goTo(name) {
				let self = this;
				self.$router.replace({
					name: name,
				});
			},
			goToGetStarted() {
				let self = this;
        if (AuthenticationManager.hasToken()) {
          const tokenObject = AuthenticationManager.getToken();
          AuthenticationManager.refreshAccessToken(tokenObject).then( ()=> {
            if (_.includes(AuthenticationManager.parseJwt().scope, "standard_tasks")) {
              self.$store.commit('setPaymentStatus', true);
              if( (self.$store.state.status.onboarding.about) || (self.$store.state.status.onboarding.location) || (self.$store.state.status.goals) || (self.$store.state.status.personalise) ) {
                self.goTo('Dashboard');
              } else {
                self.goTo('GettingStartedAboutYourself');
              }
            } else {
              self.$toastr.error('Having trouble getting started. Please email support@lowcarbprogram.com');
            }
          });
        }
			},
      continueFree() {
        let self = this;
        if( (self.$store.state.status.onboarding.about) || (self.$store.state.status.onboarding.location) || (self.$store.state.status.goals) || (self.$store.state.status.personalise) ) {
          self.goTo('Dashboard');
        } else {
          self.goTo('GettingStartedAboutYourself');
        }
      },
			processVoucher() {
				let self = this;
				self.voucher.error = false;
				self.voucher.isSending = true;
				paymentApi.validateVoucher({
					voucher: self.voucher.code.toUpperCase().trim()
				}).then(response => {
					if(response.data.error === false) {


					  let trackedVouchers = [
              'EASYHEALTH',
              'EASYHEALTH42',
              'EASYHEALTH43',
              'COMMUNITY',
              'HURRY',
              'RESEARCH51',
              'RESEARCH52',
              'RESEARCH53',
              'RESEARCH54',
              'RESEARCH55',
              'RESEARCH56',
              'LOWCARBNOW'
            ];

            let containsTrackable = (trackedVouchers.indexOf(self.voucher.code.toUpperCase().trim()) > -1);
            if(containsTrackable) {
              self.$gtag.event(self.voucher.code.toUpperCase().trim(),{
                'event_category': 'Vouchers',
                'event_label': 'Redeemed voucher code',
                'value': 1
              })
            }

            self.$gtag.event('VoucherRedemption',{
              'event_category': 'Registration',
              'event_label': 'Redeemed a voucher code',
              'value': 1
            });
						self.voucher.isSending = false;
						self.voucher.error = false;
						self.voucher.message = `${response.data.message}. Redirecting...`;
            // redirect to getting started
            self.goToGetStarted();

					}
				}, (error) => {
					let callback = error.response.data;
					if(callback.error) {
						self.voucher.isSending = false;
						self.voucher.error = true;
						self.voucher.message = callback.message;
						self.voucher.code = "";
					}
				});
			},
			getParam(param) {
				let self = this;
				return self.$route.query[param];
			},
			printInvoice() {
				window.print();
			},
      getOnBoardingStatus() {
        let self = this;
        userApi.onBoardingStatus().then(function (response) {
          self.$store.commit('setOnBoardingStatus', response.data);
        });
      },
      validateStripePayment() {
        if (_.has(this.$route.query, 'uuid')) {
        const uuid = this.$route.query.uuid
        paymentApi.validatePayment({uuid: uuid});
        this.$router.push({
          path: `/dashboard`
        });
        }

      },
			initMounted() {
				let self = this;
        self.validateStripePayment()
        self.getStats();
        self.fetchPaymentDetails();
        self.getUserPaidStatus();
        self.getOnBoardingStatus();
        let getCode = self.getCookie("voucher");
        if(getCode) {
          self.voucher.code = getCode;
        }
        if(self.hasPaymentProcessed) {
          self.$gtag.event('Paid',{
            'event_category': 'Registration',
            'event_label': 'Paid',
            'value': 1
          });
          fbq('track', 'Purchase', {
            currency: 'GBP',
            value: 29.99
          });
        }
        self.$gtag.pageview('/payment');
			},
      getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
      }
		},
		computed: {
			hasPaymentProcessed() {
				let self = this;
				return self.getParam('success');
			},
			isPaymentCancelled() {
				let self = this;
				return self.getParam('cancelled');
			},
		},
		mounted() {
			let self = this;
			self.initMounted();
		}
	}
</script>
<style lang="less">
	@import './Payment.less';
</style>



// WEBPACK FOOTER //
// Payment.vue?0ba54954